/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

import { Subject, takeUntil, filter } from 'rxjs';

import { CoreMenuService } from '@xbaht/ui/core/components/core-menus/core-menu/services/core-menu.service';
import { CoreSidebarService } from '@xbaht/ui/core/components/core-sidebars/core-sidebar/services/core-sidebar.service';
import { CoreConfigService } from '@xbaht/ui/core/services';

@Component({
  selector: 'xbaht-horizontal-menu',
  templateUrl: './horizontal-menu.component.html',
  styleUrl: './horizontal-menu.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class HorizontalMenuComponent implements OnInit, OnDestroy {
  public coreConfig: any;
  public menu: any;

  private _unsubscribe: Subject<void>;

  constructor(
    private _coreConfigService: CoreConfigService,
    private _coreMenuService: CoreMenuService,
    private _coreSidebarService: CoreSidebarService
  ) {
    this._unsubscribe = new Subject();
  }

  ngOnInit(): void {
    this._coreConfigService.config
      .pipe(takeUntil(this._unsubscribe))
      .subscribe((config: any) => {
        this.coreConfig = config;
      });

    this._coreMenuService.onMenuChanged
      .pipe(
        filter((value) => value !== null),
        takeUntil(this._unsubscribe)
      )
      .subscribe(() => {
        this.menu = this._coreMenuService.getCurrentMenu();
      });
  }

  ngOnDestroy(): void {
    this._unsubscribe.next();
    this._unsubscribe.complete();
  }
}
